import toast from "react-hot-toast";
import { CallingApp } from "../../Constant";
import { GetAccessApiToken, getSessionData } from "../../helpers/Util";
import { fetchInstance } from "../../helpers/interceptor";


const buildRequestBody = (row, tokendata, GetProcedureCode) =>
  JSON.stringify({
    User: {
      Physician: {
        ID: tokendata.doctorId,
      },
      Account: {
        ID: tokendata.companyId,
      },
      Domain: "greenyourbills.com",
      Specialty: {
        ID: tokendata.doctorSpecialtyId,
        Name: tokendata.doctorSpecialtyName,
        Code: GetProcedureCode(tokendata.doctorSpecialtyId),
      },
      ID: tokendata.userId || 'US000000000000000079',
      UserName: tokendata.userName || 'greenbills',
    },
    Appointment: {
      Patient: {
        CaseID: tokendata.caseId,
      },
      ID: row.ID,
    },
  });

export const CheckConditionForViewClick = async (row, GetProcedureCode) => {
  let AccessToken = GetAccessApiToken();
  const tokendata = getSessionData("tokenData", {});

  const response = await fetchInstance(
    `${process.env.REACT_APP_DOCTOR_API_URL}GenericAppointment/generatepdf`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${AccessToken}`,
        CallingApp: CallingApp,
      },
      body: buildRequestBody(row, tokendata, GetProcedureCode),
    },
  );

  if (response.status === 401) return null;

  try {
    return await response.json();
  } catch {
    return null;
  }
};

export const DownloadFile = async (url, success) => {
  let AccessToken = GetAccessApiToken();
  try {
    const response = await fetchInstance(url, {
      headers: {
        Authorization: `Bearer ${AccessToken}`,
        CallingApp: CallingApp,
      },
    });

    if (response.status === 401) return success(401);

    if (response.status === 404) {
      const path = new URL(url).searchParams.get("path");
      if (path) toast.error("Could not load the file");
      return success(404);
    }

    if (!response.ok) {
      toast.error("Could not load the file");
      return success(0);
    }

    const blob = await response.blob();
    success(blob);
  } catch {
    toast.error("Could not load the file");
    success(0);
  }
};
